module.exports = __webpack_public_path__ + "assets/OAxitong.df539ee3.svg";